import React from 'react';
import './MobileAppsSection.css';

const MobileAppsSection = () => {
  const apps = [
    {
      id: 'buyer',
      title: 'JMI Buyer',
      subtitle: 'Wholesale Sourcing & Order Management',
      desc: 'Browse hallmarked catalogues, compare purity and making charges, place structured purchase orders, and track your consignments.',
      badge: 'For Retailers & Showrooms',
      badgeColor: 'buyer',
      features: ['Live Bullion Price Sync', 'Instant Specification Inspection', 'Digital Invoice Vault', 'Milestone Order Tracking'],
    },
    {
      id: 'seller',
      title: 'JMI Seller',
      subtitle: 'Catalogue & Inventory Management',
      desc: 'Upload product variants, lock physical inventory, review incoming B2B purchase requests, and manage wholesale dispatches.',
      badge: 'For Manufacturers & Wholesalers',
      badgeColor: 'seller',
      features: ['Variant & Weight Tier Engine', 'Real-time Order Acceptance', 'Barcode Staging & Dispatch', 'Settlement Dashboard'],
    },
  ];

  return (
    <section className="mobile-apps-section" id="apps">
      <div className="jmi-container">
        <div className="section-header-center">
          <div className="section-label">CONNECTED ECOSYSTEM</div>
          <h2 className="section-title">
            One Network. <span className="gold-gradient-text">Two Powerful Mobile Apps.</span>
          </h2>
          <p className="section-subtitle">
            Whether sourcing ready stock or managing manufacturing distribution, 
            JMI provides purpose-built native software engineered specifically for the jewellery trade.
          </p>
        </div>

        <div className="apps-cards-grid">
          {apps.map((app) => (
            <div key={app.id} className="app-card-item">
              <div className="app-card-header">
                <span className={`app-badge ${app.badgeColor}`}>{app.badge}</span>
                <div className="app-store-icon">Google Play</div>
              </div>

              <h3 className="app-title">{app.title}</h3>
              <div className="app-subtitle">{app.subtitle}</div>
              <p className="app-description">{app.desc}</p>

              <div className="app-features-list">
                {app.features.map((feat, fIdx) => (
                  <div key={fIdx} className="app-feature-row">
                    <span className="app-feat-check">✓</span>
                    <span>{feat}</span>
                  </div>
                ))}
              </div>

              <div className="app-card-action">
                <a 
                  href={app.playLink === '#buyer-app-download' ? 'https://play.google.com/store/apps/details?id=com.jmi.jmi' : 'https://play.google.com/store/apps/details?id=com.jmi.jmiseller'}
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="google-play-btn"
                >
                  <svg className="play-store-svg" viewBox="0 0 466 511.98" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <g fillRule="nonzero">
                      <path fill="#EA4335" d="M199.9 237.8 1.4 470.17c7.22 24.57 30.16 41.81 55.8 41.81 11.16 0 20.93-2.79 29.3-8.37l244.16-139.46L199.9 237.8z"/>
                      <path fill="#FBBC04" d="m433.91 205.1-104.65-60-111.61 110.22 113.01 108.83 104.64-58.6c18.14-9.77 30.7-29.3 30.7-50.23-1.4-20.93-13.95-40.46-32.09-50.22z"/>
                      <path fill="#34A853" d="M199.42 273.45 329.27 145.1 87.9 8.37C79.53 2.79 68.36 0 57.2 0 30.7 0 6.98 18.14 1.4 41.86l198.02 231.59z"/>
                      <path fill="#4285F4" d="M1.39 41.86C0 46.04 0 51.63 0 57.2v397.64c0 5.57 0 9.76 1.4 15.34l216.27-214.86L1.39 41.86z"/>
                    </g>
                  </svg>
                  <div className="play-btn-text">
                    <span className="play-sub">GET IT ON</span>
                    <span className="play-main">Google Play</span>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MobileAppsSection;
